import moment from 'moment';

moment.updateLocale('en', {
  relativeTime: {
    future: "%s",
    past: "%s ago",
    s: 'less than a minute',
    ss: '%d seconds',
    m: "a minute",
    mm: "%d minutes",
    h: "an hour",
    hh: "%d hours",
    d: "a day",
    dd: "%d days",
    M: "a month",
    MM: "%d months",
    y: "a year",
    yy: "%d years"
  }
});

export default [ '$rootScope', '$state', '$window', 'basket', 'order', 'throttleService', '$anchorScroll', '$timeout', '$interval', 'configService', 'googleAnalytics', 'moneyService', ($rootScope, $state, $window, basket, order, throttleService, $anchorScroll, $timeout, $interval, configService, googleAnalytics, moneyService) => {

  let withinCheckout = () => {
    return !!($window.location.pathname && $window.location.pathname.indexOf('/checkout') > -1);
  };

  let checkout = {};

  checkout.setup = () => {
    checkout.optionExtras = {
      'SpaDay': {},
      'Treatment': {}
    };

    checkout.selectedOptions = {};

    checkout.createAnalytics();
  };

  checkout.setupSteps = () => {
    // Explanation: each step defines the text that shows when travelling to it either as a next destination or as a previous destination. If there are no steps ahead of it (or backwards travel should not be encouraged) there is no previous and similar for next.
    checkout.travelSteps = {
      'credit': {
        'prev': '← Select credit options',
        'next': 'Select credit options →'
      },
      'customise': {
        'prev': '← Customise your experience',
        'next': 'Customise your experience →',
      },
      'suggestions': {
        'prev': '← Suggestions',
        'next': 'Suggestions →',
      },
      'review': {
        'prev': '← Review your order',
        'next': 'Review your order →'
      },
      'payment': {
        'prev': null,
        'next': 'Payment information →',
      },
      'confirmation': {
        'prev': null,
        'next': ((checkout.gateway && checkout.gateway.none) || order.contents.total === 0) ? 'Confirm your order →' : 'Confirm your order and pay →',
        'nextid': 'order-submit'
      }
    };

    let currentStep = checkout.step ? checkout.validateStepByName(checkout.step) : checkout.validSteps[0];
    let stepIndex = checkout.getStepIndex(currentStep);
    checkout.step = currentStep;
    checkout.laststep = stepIndex > 0 ? checkout.validSteps[stepIndex - 1] : 0;
  };

  checkout.setSteps = () => {
    checkout.validSteps = [];

    if (basket.contents.has_credit) {
      checkout.validSteps.push(...[
        'credit'
      ]);
    }

    if (basket.contents.has_options) {
      checkout.validSteps.push(...[
        'customise'
      ]);
    }

    if (basket.contents.has_suggestions) {
      checkout.validSteps.push(...[
        'suggestions'
      ]);
    }

    checkout.validSteps.push(...[
      'review',
      'payment',
      'confirmation'
    ]);

    if (!checkout.travelSteps || Object.keys(checkout.travelSteps).length === 0) {
      checkout.setupSteps();
    }

    checkout.setButtonText(checkout.step);
  };

  checkout.travelNext = function () {
    checkout.saving = true;
    basket.saving = true;

    checkout.setSteps();

    let target = checkout.getStepIndex(checkout.step);

    if (target < checkout.validSteps.length) {
      checkout.laststep = target;
      checkout.step = checkout.validSteps[target + 1];
      checkout.recordAnalytics(checkout.step);
    }

    return checkout.travel();
  };

  checkout.travelPrevious = function () {
    checkout.saving = true;
    basket.saving = true;

    checkout.setSteps();

    let target = checkout.getStepIndex(checkout.step);

    checkout.recordAnalytics(checkout.validSteps[target]);

    checkout.laststep = target;
    basket.changeStatus(checkout.validSteps[target]);
    checkout.step = target > 0 ? checkout.validSteps[target - 1] : checkout.validSteps[0];
    return checkout.travel();
  };

  checkout.setButtonText = function (stepName) {
    let currentIndex = checkout.getStepIndex(stepName);
    checkout.prev = (currentIndex > 0 ? checkout.travelSteps[checkout.validSteps[currentIndex - 1]].prev : undefined);
    checkout.next = (currentIndex < checkout.validSteps.length - 1 ? checkout.travelSteps[checkout.validSteps[currentIndex + 1]].next : undefined);
    checkout.nextid = (currentIndex < checkout.validSteps.length - 1 ? checkout.travelSteps[checkout.validSteps[currentIndex + 1]].nextid : undefined);
  };

  checkout.firstStep = function () {
    checkout.step = checkout.validSteps[0];
    basket.changeStatus(checkout.step);
    checkout.setButtonText(checkout.step);
    checkout.laststep = 0;

    if (withinCheckout()) {
      $state.go(`checkout.${checkout.step}`);
    }
  };

  checkout.paymentStep = function () {
    checkout.setStepByName('payment');

    if (withinCheckout()) {
      $state.go(`checkout.${checkout.step}`);
    }
    checkout.saving = false;
  };

  checkout.setStepByName = (name) => {
    checkout.step = name;
    basket.changeStatus(checkout.step);
    checkout.setButtonText(checkout.step);
    checkout.laststep = checkout.getStepIndex(name);
  };

  checkout.travelResponseNotSuccess = () => {
    checkout.step = checkout.validSteps[checkout.laststep];

    if (basket.contents.basket_status === 'confirmation') {
      checkout.step = 'payment';
      checkout.travelFunction();
    }

    basket.saving = false;
    checkout.saving = false;

    return false;
  };

  checkout.travelResponseSuccess = () => {
    checkout.error = null;

    if (checkout.step === 'confirmation') {
      if (!basket.contents.errors || (basket.contents.errors && basket.contents.errors.length < 1)) {
        checkout.logTransaction();
        $window.location.href = `/confirmation/${basket.contents.identity_code}`;
        return;
      }

      checkout.step = 'payment';
      return;
    }

    if (withinCheckout()) {
      return $state.go(`checkout.${checkout.step}`)
        .then(() => {
          checkout.saving = false;
          basket.saving = false;
          return;
        });
    }
  };

  checkout.travelFunction = () => {
    if (basket.empty()) {
      return false;
    }

    checkout.saving = true;
    basket.saving = true;

    basket.changeStatus(checkout.step);

    return basket.submit(false, false)
      .then(response => {
        if (response && response.status !== 200) {
          order.invalidateToken();
          $interval.cancel(checkout.tokenInterval)
          return checkout.travelResponseNotSuccess();
        }

        if (basket.contents && basket.contents.client_secret) {
          return 'requires_action';
        }

        checkout.travelResponseSuccess();
      })
      .catch(error => {
        return basket.submitCatch(error);
      });
  };

  checkout.travel = throttleService.throttle(checkout.travelFunction, 750, { 'trailing': false });

  checkout.displayName = function (step) {
    if (checkout.gateway && checkout.gateway.none) {
      switch (step) {
      case 'payment':
        step = 'order';
        break;
      }
    }

    return step.replace(/-+/g, ' ')
      .replace(/\w\S*/g, txt => txt.charAt(0)
        .toUpperCase() + txt.substr(1)
          .toLowerCase());
  };

  checkout.checkTimestamp = function () {
    if (order && typeof order.contents.payment_token === 'string' && checkout.timestampDiff() > 0) {
      return true;
    }

    return false;
  };

  checkout.tokenTimestamp = function () {
    if (order.contents.payment_token_timestamp) {
      return order.contents.payment_token_timestamp;
    }

    return 0;
  };

  checkout.timestampDiff = function () {
    if (order.contents.payment_token_timestamp) {
      // Timeout the token 20secs before it actually fails, to allow time to process
      return moment.unix(checkout.tokenTimestamp())
        .diff(moment()
          .add(20, 'seconds'), 'seconds');
    }

    return 0;
  };

  checkout.displayTimestampDiff = () => {
    if (order.contents.payment_token_timestamp) {
      // Timeout the token 20secs before it actually fails, to allow time to process
      return moment.unix(checkout.tokenTimestamp())
        .subtract(20, 'seconds')
        .fromNow(true);
    }

    return '0 minutes';
  };

  checkout.validToken = function () {
    if (order.contents && (checkout.checkTimestamp() || checkout.gateway.none)) {
      return true;
    }

    return false;
  };

  checkout.originalTotal = function () {
    if (basket.contents.basket_status === 'payment'
            && order.contents
            && order.contents.basket_identity_code) {
      if (order.contents.total !== order.contents.original_total) {
        return order.contents.original_total;
      }
    }
  };

  checkout.grandTotal = function () {
    if (basket.contents.basket_status === 'payment'
            && order.contents
            && order.contents.basket_identity_code) {
      return order.contents.total;
    }

    return basket.contents.total;
  };

  checkout.reset = () => {
    $interval.cancel(checkout.tokenInterval);
    basket.changeStatus('checkout');
    return basket.submit()
      .then(() => {
        checkout.firstStep();
      });
  };

  checkout.invalidateOrder = () => {
    if (order.contents.basket_identity_code && order.contents.payment_token && basket.contents.option === 'delete_orders') {
      order.invalidateToken();
      $interval.cancel(checkout.tokenInterval);
    }

    if (checkout.step === 'payment') {
      order.generateOrder(basket.contents.identity_code);
    }
  };

  checkout.scrollToError = () => {
    $anchorScroll('content');
  };

  checkout.init = () => {
    checkout.gateway = configService.get('gateways');

    $interval.cancel(checkout.tokenInterval);

    if (basket.promise) {
      return basket.promise.then(() => {
        checkout.setup();
        checkout.setSteps();

        checkout.recordAnalytics(checkout.step);

        // If empty basket, force to first step
        if (basket.empty() || basket.contents.basket_status === 'checkout') {
          return checkout.firstStep();
        }

        let currentURL = $window.location.pathname;
        let current = currentURL.split('/')
          .pop();

        current = checkout.validateStepByName(current);

        if (currentURL.indexOf('checkout') > -1 && current !== basket.contents.basket_status) {
          checkout.step = basket.contents.basket_status;
          return checkout.travel();
        }

        checkout.step = current;
        checkout.setButtonText(current);

        $rootScope.$on('$locationChangeStart', function (event, toState) {
          event.targetScope.step = toState.split('/')
            .slice(-1)[0];
        });

        return true;
      });
    } else {
      checkout.error = [ 'No basket was found.' ];
    }
  };

  checkout.validateStepByName = (current) => {
    if (checkout.validSteps.indexOf(current) === -1) {
      return checkout.validSteps[0];
    }

    return current;
  };

  checkout.getStepIndex = (current) => {
    let index = checkout.validSteps.indexOf(current);

    if (index <= 0) {
      return 0;
    }

    if (index >= checkout.validSteps.length) {
      return checkout.validSteps.length;
    }

    return index;
  };

  checkout.createAnalytics = () => {
    const config = configService.get('analytics');
    if (!checkout.analytics && config.loadAnalytics) {
      return googleAnalytics.loadScript()
        .then(() => {
          googleAnalytics.create({
            id: config.revSpaGAID,
            name: 'revSpa'
          });

          let propertyAnalytics = config.propertyGAID;

          if (propertyAnalytics) {
            googleAnalytics.create(propertyAnalytics);
          }

          googleAnalytics.sendData();
          checkout.analytics = true;
        });
    }
  };

  checkout.recordAnalytics = (targetPage) => {
    googleAnalytics.setData('page', `/checkout/${targetPage}`);
    googleAnalytics.sendData();
  };

  checkout.logTransaction = () => {
    let currency = moneyService.getCurrencyDetails(order.contents.currency_code);
    let transaction = {
      'id': `${basket.contents.identity_code}`,
      'affiliation': `${basket.contents.property.name}`,
      'revenue': `${basket.contents.total / currency.magnitude}`,
      'currency': `${order.contents.currency_code}`
    };

    googleAnalytics.setEcommerce('addTransaction', transaction);

    googleAnalytics.sendEcommerce();
  };

  checkout.setTokenCountdown = () => {
    if (!checkout.tokenInterval && checkout.checkTimestamp()) {
      checkout.tokenInterval = $interval(() => {
        checkout.timestampRemaining = checkout.displayTimestampDiff();

        if (!checkout.checkTimestamp()) {
          $interval.cancel(checkout.tokenInterval);
          checkout.tokenInterval = null;
          return;
        }
      }, 1000)
        .catch(() => {
          // Swallow cancel error
        });

      return;
    }
  };

  checkout.addError = (error) => {
    if (!checkout.error) {
      checkout.error = [];
    }
    checkout.error.push(error);
  };

  checkout.init();

  return checkout;
} ];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/services/checkout.service.js